import { ModelBase } from '../../core/model/model-base';
import { PostalAddress } from '../../common/model/postal-address';
import { LocalDate } from '../../core/model/local-date';
import { IModel } from '../../core/service/base/data.service';
import { Address } from '../../common/model/address';

export class Landlord extends ModelBase {
  constructor() {
    super();
    this.address = new PostalAddress();
  }
  private _liveFrom: LocalDate;

  set liveFrom(value: LocalDate) {
    this._liveFrom = LocalDate.fromDate(value);
  }
  get liveFrom(): LocalDate {
    return this._liveFrom;
  }

  address: PostalAddress;
  name: string;
  companyName: string;
  email: string;
  orgNumber: string;
  password: string;
  phone: string;
  referenceName: string;
  hogiaCustomerNumber: number;
  dhCustomerNumber: number;
  maxDwellingCount: number;
  maxParkingCount: number;
  maxOtherCount: number;
  maxPremisesSqm: number;

  toString() {
    return this.companyName;
  }
}

export class LandlordUpdateModel implements IModel {
  id: string;
  address: Address;
  name: string;
  companyName: string;
  email: string;
  orgNumber: string;
  password: string;
  phone: string;
  referenceName: string;
  hogiaCustomerNumber: number;
  dhCustomerNumber: number;
  maxDwellingCount: number;
  maxParkingCount: number;
  maxOtherCount: number;
  maxPremisesSqm: number;
  liveFrom: LocalDate;
}
